import Udesk from 'Udesk';
import CustomerServiceInformationComponent from './component';

class CustomerSericeInforomationRoute extends CustomerServiceInformationComponent {
    asyncModel(flag) {
        let { sdkOptions } = this.props;

        this.privates.loading = true;

        this.actions.update();

        let params = {
            pageNum: this.privates.paging.pageNum,
            pageSize: this.privates.paging.pageSize,
            keyWord: this.privates.keyWord,
            checked: this.privates.checkExceptionData,
            status: this.privates.status,
            ordersList: this.privates.ordersList,
        };

        let grounpUrl = Udesk.business.apiPath.concatApiPath(`agentGroups`, sdkOptions);

        let departmentUrl = Udesk.business.apiPath.concatApiPath(
            `agentDepartments/all`,
            sdkOptions
        );

        let grounpDataPromise = new Promise((resolve, reject) => {
            Promise.all([Udesk.ajax.get(grounpUrl), Udesk.ajax.get(departmentUrl)]).then(
                (resp) => {
                    resolve({ grounpData: resp[0].data, departmentData: resp[1].data });
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        }).then(({ grounpData, departmentData }) => {
            const isDepartment = this.privates.activeKey === 'department';

            let id = '';

            if (this.privates.grounpId) {
                id = this.privates.grounpId;
            } else {
                if (isDepartment) {
                    if (departmentData && departmentData.length > 0) {
                        id = departmentData[0].id;
                    }
                } else {
                    if (grounpData && grounpData.length > 0) {
                        id = grounpData[0].id;
                    }
                }
            }

            let url = isDepartment
                ? Udesk.business.apiPath.concatApiPath(`agentDepartments/${id}`, sdkOptions)
                : Udesk.business.apiPath.concatApiPath(`agentGroups/${id}`, sdkOptions);

            return new Promise((resolve, reject) => {
                Udesk.ajax.post(url, params).then(
                    (resp) => {
                        resolve({ grounpData, departmentData, listData: resp });
                    },
                    (reason) => {
                        Udesk.ui.notify.error(reason.errorMsg);
                        reject(reason);
                    }
                );
            });
        });

        return {
            grounpData: grounpDataPromise,
        };
    }
    parseAsyncModel(asyncModel) {
        return asyncModel;
    }
}

export default CustomerSericeInforomationRoute;
